module.exports = __webpack_public_path__ + "static/media/tryFoods.cc7073bb.png";